import * as React from 'react';
import { connect } from 'react-redux';
import { removeLifeBeneficiary, removeLifeBeneficiaryModal, setLifeActiveBeneficiaryId } from "../../actions/lifePolicyActions";
import { navigateTo } from '../../actions/navigationActions';
import { hideMobileProfile } from '../../actions/profileActions';
import { LIFE_ADD_BENEFICIARY, LIFE_BENEFICIARY_DETAIL, LIFE_INSURANCE, LIFE_UPDATE_POLICY_PAYOUT } from "../../routes/routes";
import { UpdateBeneficiaries } from "../Beneficiary/UpdateBeneficiaries";
import './LifeUpdateBeneficiaries.css';

class LifeUpdateBeneficiaries extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            updateReminderDismissed: false,
            selectedBenefit: {},
            isInEdit: false,
            beneficiaryIdToRemove: '',
        }

        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleAddBeneficiary = this.handleAddBeneficiary.bind(this);
        this.handleViewOrUpdate = this.handleViewOrUpdate.bind(this);
        this.changeEdit = this.changeEdit.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleRemoveModal = this.handleRemoveModal.bind(this);
    }
    
    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }

    componentDidMount() {
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];
        this.setState({
            selectedBenefit: mainBenefit,
        });
        this.props.dispatchHideProfile();
    }
    
    handleBack() {
        this.handleRedirect(LIFE_INSURANCE);
    }
    
    handleAddBeneficiary() {
        this.handleRedirect(LIFE_ADD_BENEFICIARY);
    }
    
    handleViewOrUpdate(id) {
        this.props.dispatchSetActiveBeneficiaryId(id);
        this.handleRedirect(LIFE_BENEFICIARY_DETAIL);
    }
    
    async handleRemoveModal(id: string) {
        this.setState({ beneficiaryIdToRemove: id });
        await this.props.dispatchRemoveLifeBeneficiaryModal(id, this.handleRemove);
    }

    async handleRemove(id: string) {
        await this.props.dispatchRemoveLifeBeneficiary(this.state.beneficiaryIdToRemove);
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];
        if (!(mainBenefit.beneficiaries == null || mainBenefit.beneficiaries.length == 0)) {
            this.handleRedirect(LIFE_UPDATE_POLICY_PAYOUT);
        } else {
            this.handleRedirect(LIFE_INSURANCE);
        }
    }

    changeEdit() {
        this.setState({ isInEdit: !this.state.isInEdit });
    }

    public render() {
        const activeBenefitId = this.props.lifePolicy.policy.activeBenefitId;
        const mainBenefit = this.props.lifePolicy.policy.benefits.filter((ben) => ben.id === activeBenefitId)[0];

        return <>
                <UpdateBeneficiaries
                    emitHandleRemove={this.handleRemoveModal}
                    emitHandleViewOrUpdate={this.handleViewOrUpdate} 
                    emitHandleAddBeneficiary={this.handleAddBeneficiary} 
                    emitHandleBack={this.handleBack} 
                    beneficiaries={mainBenefit.beneficiaries} 
                />
        </>
    }

}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        lifePolicy: state.lifePolicy,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        dispatchRemoveLifeBeneficiary: (id: string) => dispatch(removeLifeBeneficiary(id)),
        dispatchRemoveLifeBeneficiaryModal: (id: string, cbFunc: () => any) => dispatch(removeLifeBeneficiaryModal(id, cbFunc)),
        dispatchSetActiveBeneficiaryId: (id: string) => dispatch(setLifeActiveBeneficiaryId(id)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LifeUpdateBeneficiaries);